export const getNotificationTrayOpenState = (state) => state.notificationTray.isOpen

export function getUnreadNotificationCount(state, props) {
  const { unreadTotalCount } = state.notificationTray
  if (unreadTotalCount !== null) {
    return unreadTotalCount
  }
  return props.notificationCount
}
